/**
 * Stable cost-category codes, mirroring `CostCategoryCodes` in
 * `atlas-api/src/Atlas.Domain/Entities/CostCategoryCodes.cs`.
 *
 * These identify the three categories the business logic knows about. Category
 * *names* are user-editable and differ between a seeded database ("Materials") and
 * a migrated one ("Material"), so nothing may key off them — doing so is what caused
 * commission to be paid on the whole contract instead of the labour portion.
 *
 * Typed as a const object rather than loose strings so that a typo like 'MATERIALS'
 * is a compile error instead of an amount silently routing to the wrong column.
 */
export const COST_CATEGORY_CODES = {
  MATERIAL: 'MATERIAL',
  SUBCONTRACTOR: 'SUBCONTRACTOR',
  PAYROLL: 'PAYROLL',
} as const;

export type CostCategoryCode =
  (typeof COST_CATEGORY_CODES)[keyof typeof COST_CATEGORY_CODES];
